import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {ComponentContainer, Title, Spinner, StyledSmallTitle} from './shared/styles';
import NavAnchor, {NAV_ANCHOR_OFFSET} from '../../tool-profile/components/shared/nav-anchor';
import AlternativesCard from '../../../shared/library/cards/alternatives';
import {flattenEdges} from '../../../shared/utils/graphql';
import RelatedStackups from '../../../shared/library/cards/related-stackups';
import {Query} from 'react-apollo';
import {relatedStackups} from '../../../data/tool-profile/queries';
import Circular, {LARGE} from '../../../shared/library/indicators/indeterminate/circular';
import withErrorBoundary from '../../../shared/enhancers/error-boundary';

const Container = glamorous.div({
  margin: '30px 0'
});

const ComparisonsContainer = glamorous.div({
  margin: '30px 0'
});

const Alternatives = ({tool}) => {
  const alternativeTools = flattenEdges(tool.alternativeTools);
  return (
    <ComponentContainer>
      <NavAnchor id="alternatives" offset={NAV_ANCHOR_OFFSET} />
      {tool.type === 'Package' ? (
        <Title>{tool.name} Comparisons</Title>
      ) : (
        <Title>{tool.name} Alternatives & Comparisons</Title>
      )}
      {tool.type !== 'Package' && (
        <Container>
          <StyledSmallTitle>What are some alternatives to {tool.name}?</StyledSmallTitle>
          <AlternativesCard
            items={alternativeTools}
            altPath={alternativeTools.length >= 5 ? `/${tool.slug}/alternatives` : null}
          />
        </Container>
      )}
      <Container>
        <Query query={relatedStackups} variables={{id: tool.id}} notifyOnNetworkStatusChange={true}>
          {({loading, data}) => {
            const hasData = data && data.tool;
            if (loading && !hasData)
              return (
                <Spinner>
                  <Circular size={LARGE} />
                </Spinner>
              );

            if (hasData) {
              const relatedStackups = flattenEdges(data.tool.relatedStackups);
              return (
                <Container>
                  <StyledSmallTitle>Related Comparisons</StyledSmallTitle>
                  <ComparisonsContainer>
                    <RelatedStackups
                      items={relatedStackups}
                      disableHeading={true}
                      tools={[tool]}
                      ctaText="See all comparisons"
                    />
                  </ComparisonsContainer>
                </Container>
              );
            }
          }}
        </Query>
      </Container>
    </ComponentContainer>
  );
};

Alternatives.propTypes = {
  tool: PropTypes.object
};

export default withErrorBoundary(true)(Alternatives);
